


<mat-form-field appearance="outline" >
  <ngx-spinner [zIndex]="-1" name="spLocalidad" bdColor="rgba(255,255,255,0.8)" size="small"
    color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
  <mat-label>Localidad</mat-label>
  <input matInput placeholder="Localidad" [formControl]="localidadCtrl" [matAutocomplete]="autoLocalidad" />
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<mat-autocomplete #autoLocalidad="matAutocomplete" [displayWith]="displayFn"
  (optionSelected)="onLocalidadSelected($event.option.value)">
  <mat-option *ngFor="let localidad of filteredLocalidades | async" [value]="localidad">
    {{ localidad.nombre | titlecase }}
  </mat-option>
</mat-autocomplete>
